import React from 'react';
import styles from './Footer.module.css';

function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={`${styles.container} container`}>
        <p>&copy; 2025 Zoon Sat. جميع الحقوق محفوظة.</p>
        <div className={styles.socialIcons}>
          <a href="https://t.me/zoonsat" target="_blank" rel="noopener noreferrer" title="Telegram">
            <i className="fab fa-telegram"></i>
          </a>
          <a href="https://www.instagram.com/zoon.sat/" target="_blank" rel="noopener noreferrer" title="Instagram">
            <i className="fab fa-instagram"></i>
          </a>
          <a href="https://api.whatsapp.com/send/?phone=97338187733" target="_blank" rel="noopener noreferrer" title="WhatsApp">
            <i className="fab fa-whatsapp"></i>
          </a>
        </div>
      </div>

    </footer>
  );
}

export default Footer;